import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.light,
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" align="center" sx={{ mb: 1 }}>
          © Strike the Tower {currentYear}. All Rights Reserved.
        </Typography>
        <Typography variant="body2" align="center">
          Website designed by <strong>Tinkerton Enterprises</strong>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
